<script setup lang="ts">

</script>

<template>
	<div class="layout layout--authentication">
		<div class="main-container">
			<div class="main-wrapper">
				<main class="main">
					<div class="authentication-wrapper">
						<slot />

						<HmCopyright app="auth" has-help is-absolute />
					</div>
				</main>
			</div>
		</div>
	</div>
</template>
